// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4826) return "index.undefined.css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};